<template>
  <aside class="min-w-max flex flex-col gap-2">
    <slot />
  </aside>
</template>

<script>
export default {
  name: "UiSidebar",
};
</script>
